<template>
    <div style="margin-bottom: var(--altura-menu-padrao);padding-bottom: var(--padding-padrao);">

        <!-- titulo da classe  -->
        <TituloDePaginaView :titulo="this.$store.state.classeSelecionada" :subtitulo="this.$store.state.classeSelecionadaDescricao" :cor="'white'"/>

        <br>

        <!-- aqui todos os itens aparecem na lista, independente de serem combos, ou mercadorias, etc -->

        <div  class="display-items">
            <div v-for="item in itensVenda" :key="item['id']" class="cada-item" style="margin-bottom: var(--padding-padrao);">
                <CadaItemVenda :item="item"/>
            </div>
        </div>

    </div>
</template>

<script>
import {  mapState } from 'vuex';
import CadaItemVenda from '../ListaItensVenda/CadaItemVenda.vue'
import TituloDePaginaView from "../Base/TituloDePagina.vue"
export default {

    name: "ItensVenda",

    data() {
        return {
            classeSelecionada: this.$store.state.classeSelecionada,
        }
    },

    computed: {
        ...mapState([
            'produtos',
            'currentStr',
            'itensVenda'
        ]),
        porColunas() {
            return this.$store.state.organizarPorColunas
        }
    },

    components: {
        CadaItemVenda,TituloDePaginaView
    }

}
</script>

<style scoped>
h3{
    margin-top: 0;
    margin-bottom: 0;
}
p {color: white}


/* desktops  */
@media only screen and (min-width: 720px) {
    .display-items {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        width: 100%;
        /* padding-inline: 10px; */
    }

    .cada-item {
        height: 100%;
    }
}
/* mobiles  */
@media only screen and (max-width: 720px) {
    .display-items {
        margin-inline: 10px;
    }

}




</style>